import { Box, Container, Typography, Stack, Link } from "@mui/material";
import costlix from "../../assets/images/logoB.png";
import oglitz from "../../assets/images/Oglitz-main-icon.jpg";

export function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        position: "relative",
        py: { xs: 5, md: 6 },
        background: `
          linear-gradient(
            180deg,
            rgba(233,79,55,0.95) 0%,
            rgba(216,67,48,1) 100%
          )
        `,
        color: "#fff",
        overflow: "hidden",

        /* Premium soft glow */
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(circle at top, rgba(255,255,255,0.15), transparent 60%)",
          pointerEvents: "none",
        },
      }}
    >
      <Container maxWidth="md" sx={{ position: "relative" }}>
        <Stack spacing={1} alignItems="center" textAlign="center">
          {/* Logos */}
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            alignItems="center"
          >
            <Box
              component="img"
              src={costlix}
              alt="Costlix"
              sx={{ height: { xs: 34, md: 40 }, borderRadius: "6px" }}
            />
            <Link
              href="https://oglitz.com"
              target="_blank"
              underline="none"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                color: "#fff",
              }}
            >
              <Box
                component="img"
                src={oglitz}
                alt="Oglitz Software Pvt. Ltd."
                sx={{
                  height: { xs: 34, md: 40 },
                  borderRadius: "6px",
                }}
              />
            </Link>
          </Stack>

          {/* Brand description */}
          <Typography
            sx={{
              maxWidth: 560,
              fontSize: "0.95rem",
              lineHeight: 1.7,
              opacity: 0.9,
            }}
          >
            <strong>Costlix</strong> is a smart project cost estimator that
            helps founders, teams, and businesses plan software budgets with
            real-world benchmarks and transparent pricing logic.
          </Typography>

          {/* Divider */}
          <Box
            sx={{
              width: 120,
              height: 1,
              backgroundColor: "rgba(255,255,255,0.35)",
              my: 1,
            }}
          />
          <Typography
            sx={{
              fontSize: "0.85rem",
            }}
          >
            Powered by{" "}
            <Typography
              component={Link}
              href="https://oglitz.com"
              target="_blank"
              sx={{
                color: "#fff",
                textDecoration: "none",
                fontSize: "0.85rem",
                m: 0,
                p: 0,
              }}
            >
              Oglitz Software Pvt Ltd.
            </Typography>
          </Typography>
          {/* Copyright */}
          <Typography
            sx={{
              fontSize: "0.85rem",
              opacity: 0.8,
            }}
          >
            © {new Date().getFullYear()} Costlix.in All rights reserved.
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}
